import { fireSEQ } from '@driftt/seq-launcher'
import {
  CustomerAPI,
  DriftAPI,
  SyncAPI 
} from 'api'
export const uploadCsv = async (data, onUploadProgress) => (
  CustomerAPI.post(`/csvimport`, data, {
    headers: { 'Content-type': 'multipart/form-data' },
    onUploadProgress: onUploadProgress
  })
)

export const startImport = async (id, data, csvName) => (
  CustomerAPI.post(`/csvimport/${id}/start`, { ...data }, {
    params: {
      csvName,
      createSegment: true 
    } 
  })
)

export const generateImportErrorCSV = async id => (
  CustomerAPI.get(`/syncjob/${id}?exportErrors=true`)
)

export const getContactProperties = async id => (
  CustomerAPI.get(`/property_definitions`)
)

export const getMarketoLists = ({
  query,
  listType = 'all',
  offset = 0,
  size = 200 
}) => (
  SyncAPI.get(`/marketo/lists?q=${query}&type=${listType}&offset=${offset}&maxReturn=${size}`)
)

export const getMarketoFetchMetadata = () => (
  SyncAPI.get('/marketo/lists/fetch')
)

export const forceFetchFromMarketo = ({ force }) => (
  SyncAPI.post('/marketo/lists/fetch', { force })
)

export const syncMarketoLists = ({ listIds }) => (
  SyncAPI.post('/marketo/lists/sync?createOnly=true', listIds)
    .then((data) => {
      fireSEQ('CRM_SEGMENT_SYNC')
      return data
    })
)

export const pauseMarketoLists = ({ listIds }) => (
  SyncAPI.post('/marketo/lists/pause', listIds)
)

export const suggestImportSource = ({ suggestion }) => (
  CustomerAPI.post(`/integrationsuggestions/imports?suggestion=${suggestion}`)
)

export const getMarketoSyncErrors = (orgId, startFrom = 0, size = 25) => (
  SyncAPI.get(`/marketo/errors`, {
    params: {
      orgId,
      from: startFrom,
      size 
    } 
  })
)

export const getMarketoEventLogs = ({ jobId }) => (
  DriftAPI.get(`/business/events/auth?sourceId=marketo_sync.${jobId}&unit=seconds&start=${Date.now()}&offset=-320600`)
)

export const getBusinessEventLogs = ({
  sourceId,
  unit,
  start,
  offset 
}) => (
  DriftAPI.get(`/business/events/auth?sourceId=${sourceId}&unit=${unit}&start=${start}&offset=${offset}`)
)

export const getPardotLists = ({
  query,
  type = 'ALL',
  maxReturn = 200,
  offset = 0 
}) => (
  SyncAPI.get(`/pardot/lists?q=${query}&type=${type}&maxReturn=${maxReturn}&offset=${offset}`)
)

export const syncPardotLists = ({ listIds }) => (
  SyncAPI.post('/pardot/lists/sync', listIds)
)

export const pausePardotLists = ({ listIds }) => (
  SyncAPI.post('/pardot/lists/pause', listIds)
)

export const fetchFromPardot = () => (
  SyncAPI.post('/pardot/lists/fetch', {})
)

export const getPardotSyncErrors = ({
  orgId,
  startFrom = 0,
  size = 25 
}) => (
  SyncAPI.get('/pardot/errors/page', {
    params: {
      orgId,
      from: startFrom,
      size 
    } 
  })
)

export const getHubspotLists = ({
  query,
  type = 'ALL',
  maxReturn = 250,
  offset = 0 
}) => (
  SyncAPI.get(`/hubspot/sync_lists?q=${query}&type=${type}&maxReturn=${maxReturn}&offset=${offset}`)
)

export const syncHubspotLists = ({ listIds }) => (
  SyncAPI.post('/hubspot/sync_lists/sync', listIds)
    .then((data) => {
      fireSEQ('CRM_SEGMENT_SYNC')
      return data
    })
)

export const pauseHubspotLists = ({ listIds }) => (
  SyncAPI.post('/hubspot/sync_lists/pause', listIds)
)

export const forceFetchFromHubSpot = ({ force }) => (
  SyncAPI.post('/hubspot/sync_lists/fetch', { force })
)

export const getHubspotSyncErrors = ({
  orgId,
  startFrom = 0,
  size = 25 
}) => (
  SyncAPI.get('/pardot/errors/page', {
    params: {
      orgId,
      from: startFrom,
      size 
    } 
  }) // TODO: jeff
)
